export default __webpack_public_path__ + "static/media/manNoCheckedIcon.9d604211.svg";